import { Set } from '~commonInfra/utils/Set';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

import { IControlledPermissionItemInfo } from '../../spacesPlatform/models/resourceInfoParts';
import { AuthorizableType } from '../types/AuthorizableType';

export enum LockUnlockPermissionsState {
  Locked,
  Unlocked,
  Mixed
}

export enum NestedProjectsPermissionsState {
  Included,
  Excluded,
  Mixed
}

export module LockStatusHelper {

  // Returns true if all numbers in the provided array are the same
  function allSame(arr: number[]): boolean {
    return arr.every((item: number) => arr[0] === item);
  }

  export function getCombinedStatusOfAllItems(
    lockStates: LockUnlockPermissionsState[]
  ): LockUnlockPermissionsState {
    return allSame(lockStates) ? lockStates[0] : LockUnlockPermissionsState.Mixed;
  }

  export function getCombinedStatusOfNestedProjectsState(
    nestedProjectsState: NestedProjectsPermissionsState[]
  ): NestedProjectsPermissionsState {
    return allSame(nestedProjectsState) ? nestedProjectsState[0] : NestedProjectsPermissionsState.Mixed;
  }

  export function getLockStatusOfAllContainers(
    containers: Set<IControlledPermissionItemInfo>
  ): LockUnlockPermissionsState[] {
    return containers.map((container: IControlledPermissionItemInfo) => {
      return container.controlledPermissionsEnabled
        ? LockUnlockPermissionsState.Locked
        : LockUnlockPermissionsState.Unlocked;
    });
  }

  export function getNestedProjectsStatusOfAllContainers(
    containers: Set<IControlledPermissionItemInfo>
  ): NestedProjectsPermissionsState[] {
    return containers.map((container: IControlledPermissionItemInfo) => {
      return container.nestedProjectsPermissionsIncluded
        ? NestedProjectsPermissionsState.Included
        : NestedProjectsPermissionsState.Excluded;
    });
  }

  export function getLockState(
    containers: Set<IControlledPermissionItemInfo>
  ): LockUnlockPermissionsState {
    return getCombinedStatusOfAllItems(getLockStatusOfAllContainers(containers));
  }

  export function getNestedProjectsState(
    containers: Set<IControlledPermissionItemInfo>
  ): NestedProjectsPermissionsState {
    return getCombinedStatusOfNestedProjectsState(getNestedProjectsStatusOfAllContainers(containers));
  }

  export function isDatabaseInProject(authType: AuthorizableType, authorizables: Set<any>) {
    const isDatabase = authType === AuthorizableType.DATABASE;
    const dbsInProjectsPostMVP = getSessionManagementServiceInstance().databasesInProjectsPostMVPEnabled();
    let dbIsAssigned = false;
    if (isDatabase && dbsInProjectsPostMVP) {
      dbIsAssigned = authorizables.any(p => {
        return p.containerName || p.projectName;
      });
    }
    return dbIsAssigned;
  }
}
